module.exports = __webpack_public_path__ + "img/2_AR-mb.400f1a84.png";